import { EXPERIENCE, InsuranceProducts } from "../../constants";
import { PHASE } from "../../routeConfig";
import useAppSelector from "../../hooks/useAppSelector";
import useGetPrefillInitialRoute from "../unlinked-application/useGetPrefillIniitalRoute";
import useIsFlagOn from "../feature-flags/hooks/useIsFlagOn";
export default function useInitialRoute() {
    var isPrefill = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var isReturnApplication = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.RETURN_APPLICANT; });
    var didPrefillAuto = useAppSelector(function (state) {
        return state.unlinkedApplication.prefill.auto.data &&
            state.unlinkedApplication.prefill.auto.issuer;
    });
    var didPrefillHome = useAppSelector(function (state) {
        return state.unlinkedApplication.prefill.home.data &&
            state.unlinkedApplication.prefill.home.issuer;
    });
    var autoPrefillNextRoute = useGetPrefillInitialRoute("auto");
    var homePrefillNextRoute = useGetPrefillInitialRoute("home");
    var _a = useAppSelector(function (state) { return state.configuration; }), experience = _a.experience, policyOnly = _a.policyOnly, products = _a.products;
    var issuerPageFirst = useIsFlagOn("unlinkedApplication_issuerPageFirst_frontend");
    var isAutoOnly = products.length === 1 && products.includes(InsuranceProducts.Auto);
    var isHomeOnly = products.length === 1 && products.includes(InsuranceProducts.Home);
    var isMonolineRemarketingSearch = experience === EXPERIENCE.REMARKETING && policyOnly === false;
    var isBundleRemarketingSearch = experience === EXPERIENCE.BUNDLE_REMARKETING;
    var isRemarketingSearch = isMonolineRemarketingSearch || isBundleRemarketingSearch;
    if (isRemarketingSearch || isReturnApplication) {
        return PHASE.QUOTE_LOADING;
    }
    if (isPrefill && didPrefillAuto) {
        return autoPrefillNextRoute;
    }
    if (isPrefill && didPrefillHome) {
        return homePrefillNextRoute;
    }
    if (products && products.length > 1) {
        return PHASE.SELECT_INSURANCE_PRODUCT;
    }
    /**
     * This likely can be fully removed, currently controlled via split
     */
    if (issuerPageFirst) {
        if (isAutoOnly) {
            return PHASE.SELECT_AUTO_ISSUER;
        }
        if (isHomeOnly) {
            return PHASE.HOME_SELECT_ISSUER;
        }
    }
    if (isHomeOnly) {
        return PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS;
    }
    return PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR;
}
